import { render, staticRenderFns } from "./CultivationSection.vue?vue&type=template&id=75462913&scoped=true"
import script from "./CultivationSection.vue?vue&type=script&lang=js"
export * from "./CultivationSection.vue?vue&type=script&lang=js"
import style0 from "./CultivationSection.vue?vue&type=style&index=0&id=75462913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75462913",
  null
  
)

export default component.exports